import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';
import { useAuth } from './AuthContext';

const ProgramsContext = createContext(null);

export function ProgramsProvider({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [programs, setPrograms] = useState([]);
  const [programMap, setProgramMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setLoading(false);
      return;
    }
    setLoading(true);
    api.get('/programs')
      .then(res => {
        const rows = res.data;
        setPrograms(rows);
        const map = {};
        rows.forEach(p => { map[p.code] = p.name; });
        setProgramMap(map);
      })
      .catch(err => console.error('Failed to load programs:', err))
      .finally(() => setLoading(false));
  }, [user, authLoading]);

  function programName(code) {
    return programMap[code] || code;
  }

  return (
    <ProgramsContext.Provider value={{ programs, programMap, programName, loading }}>
      {children}
    </ProgramsContext.Provider>
  );
}

export function usePrograms() {
  const ctx = useContext(ProgramsContext);
  if (!ctx) throw new Error('usePrograms must be used within ProgramsProvider');
  return ctx;
}
